/* Global imports. */
import React from "react";
import HTMLReactParser from "html-react-parser";

/* Hook imports. */
import useScript from "@hooks/useScript";

interface Props {
  html: string;
  script: string;
}

function Embed({ html, script }: Props) {
  if (script) useScript(script);
  return html && HTMLReactParser(html);
}

export default Embed;
